import {defineStore} from "pinia";
import {useAuthStore} from "@/stores/authStores";
import api from '@/services/api'

export const useSDSStore = defineStore('sds', {
    state: () => ({
        messages: [],

        history: [], // to be fetched from BE

        selectedMessage: [], // to be set when a message is selected
    }),

    getters: {
        getLatest() {
            return this.messages.length > 0 ? this.messages[0] : null;
        }
    },


    actions: {
        acknowledge() {
            var ids = [];
            this.selectedMessage.forEach(msg => {
                ids.push(msg.value.id);

            });
            api.put(
                '/sds/acknowledge',
                {},
                {
                    headers: {'Content-Type': 'application/json'},
                    params: {ids: ids.join(',')}
                }
            )
                .then(response => {
                    console.log(response);
                    this.fetchInbox();
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });
            this.selectedMessage = []; // clear the selected message            this.selectedMessage = []; // clear the selected message
        },

        acknowledgeAll() {
            var ids = [];
            this.messages.forEach(msg => {
                ids.push(msg.id);

            });
            api.put(
                '/sds/acknowledge',
                {},
                {
                    headers: {'Content-Type': 'application/json'},
                    params: {ids: ids.join(',')}
                }
            )
                .then(response => {
                    console.log(response);
                    this.fetchInbox();
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });
            this.selectedMessage = []; // clear the selected message

        },

        newMessage(data) {
            console.log("SDS store, new data: " + data);
            this.fetchInbox();

            const newMessage = {
                id: data.value.msgid,
                sender: data.value.from,
                receiver: data.value.to,
                time: Date.now(),
                message: data.value.content,
                ack: false,
            };

            api.post(
                '/sds/newMsg',
                newMessage,
                {headers: {'Content-Type': 'application/json'}}
            )
                .then(response => {
                    console.log(response);
                    this.fetchInbox();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });

            //this.messages.unshift(newMessage); // add new message to the beginning of the array
        },

        onMessageSent(data) {
            console.log("SDS store, new data: " + data);

            const newOutgoingMessage = {
                id: data.value.msgid,
                sender: data.value.from,
                receiver: data.value.to,
                time: Date.now(),
                message: data.value.content,
                ack: false,
            };

            api.post(
                '/sds/newMsg',
                newOutgoingMessage,
                {headers: {'Content-Type': 'application/json'}}
            )
                .then(response => {
                    console.log(response);
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });

            //this.storeSentMessage(newOutgoingMessage);
        },

        storeSentMessage(sds) {
            console.log("SDS store sent new sds: " + sds)
            this.history.unshift(sds); // add new message to the beginning of the array
        },

        fetchHistory() {
            api.get('/sds/getHistory', {
                params: {
                    user: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    this.history = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history:", error);
                });
        },

        fetchInbox() {
            api.get('/sds/getInbox', {
                params: {
                    user: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    this.messages = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history:", error);
                });
        },
    },
})